import { render, staticRenderFns } from "./Bars.vue?vue&type=template&id=081f22c4&scoped=true&"
import script from "./Bars.vue?vue&type=script&lang=js&"
export * from "./Bars.vue?vue&type=script&lang=js&"
import style0 from "./Bars.vue?vue&type=style&index=0&id=081f22c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f22c4",
  null
  
)

export default component.exports